/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contracts_Primary_DocumentInputs */

const cs_contracts_primary_document = /** @type {(inputs: Contracts_Primary_DocumentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hlavní dokument`)
};

const en_contracts_primary_document = /** @type {(inputs: Contracts_Primary_DocumentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Primary document`)
};

/**
* | output |
* | --- |
* | "Primary document" |
*
* @param {Contracts_Primary_DocumentInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const contracts_primary_document = /** @type {((inputs?: Contracts_Primary_DocumentInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contracts_Primary_DocumentInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_contracts_primary_document(inputs)
	return cs_contracts_primary_document(inputs)
});